module.exports = __webpack_public_path__ + "static/11-f3783fd9a9d4ee2c93954dcfffbcf5d4.jpeg";